/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 06.08.13, 14:55
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { EnvGlobalsHandler } from "../../EnvGlobalsHandler";
import { IEnvironmentGlobals } from "../../IEnvironmentGlobals";
import { SimpleCommand } from './../../../commanding/SimpleCommand';


import Container = createjs.Container;

export class BasicInitLoggerCommand extends SimpleCommand {
    protected stage: Container;

		/*final*/ public execute(commandVars: any = null): void {
        // For some loggers is necessary to have a instance of stage
        if (commandVars && commandVars instanceof Container) {
            this.stage = (<Container>commandVars);
        }

        // TODO: @HTML5 - need a different solution for logging
        /*let sos: ILogMeisterConnector = new SosMaxConnector();
        sos.format = LoggingConstants.FORMAT_DEFAULT_SOS;

        // Default logger target
        LogMeister.addLogger(sos);

        // Log level default threshold
        LogMeister.setLevelThreshold(Level.DEBUG);*/

        this.configureCoreLogChannels();

        // Initialize custom settings
        this.configureLogger();

        // Logger enabling
        if (this.env.urlVariables.forceToShowLogger || this.env.isLocal || this.env.isTest) {
            this.enableLogger = true;
        }
        else {
            this.enableLogger = false;
        }
    }

    private configureCoreLogChannels(): void {
        // TODO: Live environment: Activate all channels
        // TODO: @HTML5 - need a different solution for logging
        /*let cc: any[] = [];
        cc.push(CountryDetectionLogChannel);
        cc.push(LoadingLogChannel);
        cc.push(SmartfoxClientLogChannel);
        //			cc.push( TrackingLogChannel );

        ChannelConfigurator.instance.addChannels(cc);*/
    }

    protected configureLogger(): void {
        // hook to override
    }

    private set enableLogger(flag: boolean) {
        // TODO: @HTML5 - need a different solution for logging
        //LogMeister.setLevel(Level.ALL, flag);
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}

